module.exports = __webpack_public_path__ + "static/business-04c086ddcbb6d56e4c6ce0c16e123eb0.jpg";